import { ChangeDetectionStrategy, Component, computed, Signal, ViewEncapsulation } from '@angular/core';
import { PlycaUiTableComponent } from '../table.component';
import { PlycaUiButtonGenericComponent } from '../../../atoms/buttons/button-generic/button-generic.component';
import { TableDemoPagination, TableHeaders } from './_config/table-demo.model';
import { TableDemoData, TableHeader } from './_config/table-demo.const';

@Component({
  selector: 'plyca-ui-table-demo',
  templateUrl: './table-demo.component.html',
  standalone: true,
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PlycaUiTableComponent, PlycaUiButtonGenericComponent]
})
export class PlycaUiTableDemoComponent {
  public tableHeader: TableHeaders[] = TableHeader;
  public tableDataSig: Signal<TableDemoPagination> = computed(() => TableDemoData);

  public onClickRowSelected(event): void {
    console.error('click-row-selected', event);
  }

  public onDoubleClick(event): void {
    console.error('click-double-click', event);
  }

  public onClickPageChange(event): void {
    console.error('click-page-change', event);
  }

  public onClickTableButton(event): void {
    console.error('click-table-action', event);
  }
}
